import styled from "styled-components";

const SidebarItemMenu = styled.li`
  color: #f3f3f3;
  padding-left: 10%;
  padding-top: 2%;
  padding-bottom: 2%;
`;

export default SidebarItemMenu;
